import { PerfMarks } from '@visa/lib-instrumentation';
import collapsedlogger from './collapsed-logger';
import { pushGtmData } from './gtm';

const ss = '::';
const namespace = ['visa', 'perf'].join(ss);

export const marks = {
  activityCallComplete: [namespace, 'activityCall', 'Complete'].join(ss),
  isRecognizedComplete: [namespace, 'isRecognized', 'Complete'].join(ss),
  isRecognizedStart: [namespace, 'isRecognized', 'Start'].join(ss),
  sidtokenCallComplete: [namespace, 'sidtokenCall', 'Complete'].join(ss),

  spawnErmCookieEnd: [namespace, 'spawnErmCookie', 'End'].join(ss),
  spawnErmCookieStart: [namespace, 'spawnErmCookie', 'Start'].join(ss),

  spawnIdTokenEnd: [namespace, 'spawnIdToken', 'End'].join(ss),
  spawnIdTokenStart: [namespace, 'spawnIdToken', 'Start'].join(ss)
};

// Explicit measures that cannot necessarily leverage START/END conventions
const measures = [
  {
    budget: 1500,
    end: marks.activityCallComplete,
    name: 'isRecognized to /activity complete',
    start: marks.isRecognizedStart
  },
  {
    budget: 1500,
    end: marks.sidtokenCallComplete,
    name: 'isRecognized to /sidtoken complete',
    start: marks.isRecognizedStart
  },
  {
    budget: 2000,
    end: marks.isRecognizedComplete,
    name: 'isRecognized elapsed',
    start: marks.isRecognizedStart
  },
  {
    budget: 500,
    end: marks.spawnErmCookieEnd,
    name: '/spawn ERM elapsed',
    start: marks.spawnErmCookieStart
  },
  {
    budget: 500,
    end: marks.spawnIdTokenEnd,
    name: '/spawn ID Token elapsed',
    start: marks.spawnIdTokenStart
  }
];

// munge event here as needed
const gtmHelper = event => {
  collapsedlogger(['[PERF]', event]); // eslint-disable-line
  pushGtmData(event);
};

const Perf = new PerfMarks(namespace, measures, gtmHelper);
Perf.debug = /^(.*;)?\s*_debug\s*=/.test(document.cookie);

export const mark = Perf.mark;
